import { Component, Input, ViewChild, TemplateRef, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'mde-popover',
  template: `<ng-template><div class="mde-popover-panel"><ng-content></ng-content></div></ng-template>`,
  exportAs: 'mdePopover',
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class MdePopoverComponent {
  @Input() mdePopoverOverlapTrigger = false;
  @Input() mdePopoverCloseOnClick = true;
  @Input() mdeFocusTrapEnabled = true;

  @ViewChild(TemplateRef, { static: true }) templateRef!: TemplateRef<any>;
}
